import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import InputGroup from 'react-bootstrap/lib/InputGroup';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import $ from 'jquery';
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import Utils from '../../utils/utils';
import InputPassword from '../form/InputPassword';
import InputDropdown from '../form/InputDropdown';
import Api from '../../api/Api';
import User from '../../models/User';
import { SigninLink } from '../auth/SigninLink';
import useGTM from '../analytics/useGTM';
import Analytics from '../../utils/analytics';
import { NAVIGATION_ACTION, NAVIGATION_AREAS, NAVIGATION_TEXT } from '../analytics/analytics-constants';

export class EmailSignup extends React.Component {
    static propTypes = {
        onLogin: PropTypes.func.isRequired,
        onClick: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            sponsor: '',
            errors: null,
            cgu: false,
            submit: false,
            hiddenPassword: true,
            hiddenSponsor: true,
            hasZeroBounceError: false
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.signin = this.signin.bind(this);
        this.formValidateEmail = this.formValidateEmail.bind(this);
        this.formValidatePassword = this.formValidatePassword.bind(this);
        this.formValidateFirstname = this.formValidateFirstname.bind(this);
        this.formValidateLastname = this.formValidateLastname.bind(this);
        this.formValidateSponsorCode = this.formValidateSponsorCode.bind(this);
        this.checkSponsorCode = this.checkSponsorCode.bind(this);
        this.handleOnDropdownSponsorCode = this.handleOnDropdownSponsorCode.bind(this);
        this.handleOnChangeSponsorCode = this.handleOnChangeSponsorCode.bind(this);
        this.clearFieldError = this.clearFieldError.bind(this);
        this.onTrackNavigationButton = this.onTrackNavigationButton.bind(this);
    }

    open() {
        const { onClick } = this.props;

        this.setState({ showModal: true });
        if (onClick) onClick('email-sign-up');

        $('.modal-signup').parent().parent().hide();
    }

    close() {
        $('.modal-signup').parent().parent().show();
        this.setState({
            showModal: false,
            errors: null,
            submit: false
        });
    }

    handleChange(e) {
        let elementValue = e.target.value;
        if (e.target.type === 'checkbox') {
            elementValue = e.target.checked;
        }

        this.setState({
            [e.target.name]: elementValue
        });
    }

    onTrackNavigationButton(area, text) {
        const { fetchNavigation } = useGTM(null);
        Analytics.trackGTM('button', fetchNavigation(NAVIGATION_ACTION.CLICK, area, text));
    }

    handleOnDropdownSponsorCode(isVisible) {
        this.setState({ hiddenSponsor: !isVisible });
    }

    handleOnChangeSponsorCode(e) {
        const { value } = e.target;

        if (_.isEmpty(value)) {
            this.clearFieldError('sponsor');
        }

        this.handleChange(e);
    }

    clearFieldError(field) {
        if (this.state.errors) {
            const errors = { ...this.state.errors, [field]: undefined };
            this.setState({ errors });
        }
    }

    validateField(field, value) {
        if (field === 'sponsor') {
            if (!_.isEmpty(value)) {
                return this.checkSponsorCode(value).then((error) => ({
                    ...error,
                    field
                }));
            }
        } else if (!value || value === '' || value === null) {
            return { field, errors: [`${field}_null`] };
        } else if (field === 'password') {
            if (!User.USER_PWD_POLICY.test(value)) {
                return { field, errors: ['password_policy'] };
            }
        } else if (field === 'email') {
            const re = /\S+@\S+\.\S+/;
            if (!re.test(value)) {
                return { field, errors: ['email_invalid'] };
            }
        }
    }

    formValidate(fieldsToValidate) {
        return new Promise((resolve) => {
            const currentErrors = Object.assign({}, this.state.errors);
            let hasError = false;
            const promises = [];

            for (const field of fieldsToValidate) {
                const promise = this.validateField(field, this.state[field]);
                promises.push(
                    promise
                        ? promise
                        : new Promise((resolveNoError) => {
                              resolveNoError({ field, errors: undefined });
                          })
                );
            }

            Promise.all(promises).then((values) => {
                values.forEach((value) => {
                    currentErrors[value.field] = { errors: value.errors };
                    if (value.errors) {
                        hasError = true;
                    }
                });

                this.setState({ errors: currentErrors }, () => {
                    resolve(hasError);
                });
            });
        });
    }

    formValidateEmail() {
        this.formValidate(['email']);
    }

    formValidatePassword() {
        this.formValidate(['password']);
    }

    formValidateFirstname() {
        this.formValidate(['first_name']);
    }

    formValidateLastname() {
        this.formValidate(['last_name']);
    }

    formValidateSponsorCode() {
        this.formValidate(['sponsor']);
    }

    checkSponsorCode(value) {
        return Api.Sponsor.getGodfatherBySponsorKey(value)
            .then((user) => {
                if (!user) {
                    return { errors: ['signup.referral.error'] };
                }
            })
            .catch(() => ({ errors: ['signup.referral.error'] }));
    }

    onSubmit(e) {
        e.preventDefault();

        this.formValidate(['first_name', 'last_name', 'email', 'password', 'sponsor', 'cgu']).then(
            (hasError) => {
                if (hasError) {
                    return false;
                }

                this.setState({ submit: true, hasZeroBounceError: false });

                const data = {
                    email: this.state.email,
                    password: this.state.password,
                    first_name: this.state.first_name,
                    last_name: this.state.last_name,
                    sponsor: this.state.sponsor
                };

                this.props.onLogin(data).catch((error) => {
                    this.setState({ submit: false });
                    try {
                        const { errors } = JSON.parse(error.responseText);

                        if (errors === 'zero-bounce.email.error') {
                            this.setState({ hasZeroBounceError: true });
                            return;
                        }

                        this.setState({
                            errors: errors.form.children
                        });
                    } catch (err) {
                        const message = Utils.getErrorMessage(error);
                        sweetAlert(i18n.t('common:an_error_occured'), message, 'error');
                    }
                });
            }
        );
    }

    getValidationState(field) {
        if (this.getErrors(field)) {
            return 'error';
        }
    }

    getErrors(field) {
        if (
            this.state.errors &&
            this.state.errors[field] !== undefined &&
            this.state.errors.hasOwnProperty(field) &&
            this.state.errors[field].hasOwnProperty('errors')
        ) {
            return this.state.errors[field].errors;
        }
    }

    signin(e) {
        e.preventDefault();
        this.close();
        $('#signin').click();
    }

    hasEmailNotUniqueError() {
        return this.state.errors?.email?.errors;
    }

    render() {
        return (
            <React.Fragment>
                <Button block bsStyle="primary" bsSize="large" onClick={this.open}>
                    <i className="fa fa-envelope-o"></i>
                    {i18n.t('common:signup_email')}
                </Button>
                <Modal
                    dialogClassName="modal-login modal-signup-email"
                    show={this.state.showModal}
                    onHide={this.close}
                >
                    <Modal.Header>
                        <i className="icon-angle-left" onClick={this.close} aria-hidden="true"></i>
                        <Modal.Title>{i18n.t('common:create_account')}</Modal.Title>
                        <span className="separator"></span>
                    </Modal.Header>
                    <Modal.Body>
                        <form method="post" onSubmit={this.onSubmit}>
                            <FormGroup
                                controlId="first_name"
                                bsSize="large"
                                validationState={this.getValidationState('first_name')}
                            >
                                <ControlLabel srOnly>{i18n.t('user:firstname')}</ControlLabel>
                                <InputGroup>
                                    <FormControl
                                        type="text"
                                        name="first_name"
                                        value={this.state.first_name}
                                        placeholder={i18n.t('user:firstname')}
                                        onChange={this.handleChange}
                                        onBlur={this.formValidateFirstname}
                                    />
                                    <ControlLabel htmlFor="first_name" bsClass="input-group-addon">
                                        <InputGroup.Addon bsClass="">
                                            <Glyphicon glyph="user" />
                                        </InputGroup.Addon>
                                    </ControlLabel>
                                </InputGroup>
                                {this.renderError('first_name')}
                            </FormGroup>

                            <FormGroup
                                controlId="last_name"
                                bsSize="large"
                                validationState={this.getValidationState('last_name')}
                            >
                                <ControlLabel srOnly>{i18n.t('user:lastname')}</ControlLabel>
                                <InputGroup>
                                    <FormControl
                                        type="text"
                                        name="last_name"
                                        value={this.state.last_name}
                                        placeholder={i18n.t('user:lastname')}
                                        onChange={this.handleChange}
                                        onBlur={this.formValidateLastname}
                                    />
                                    <ControlLabel htmlFor="last_name" bsClass="input-group-addon">
                                        <InputGroup.Addon bsClass="">
                                            <Glyphicon glyph="user" />
                                        </InputGroup.Addon>
                                    </ControlLabel>
                                </InputGroup>
                                {this.renderError('last_name')}
                            </FormGroup>

                            <FormGroup
                                controlId="email"
                                bsSize="large"
                                validationState={this.getValidationState('email')}
                            >
                                <ControlLabel srOnly>{i18n.t('user:email')}</ControlLabel>
                                <InputGroup>
                                    <FormControl
                                        type="text"
                                        name="email"
                                        value={this.state.email}
                                        placeholder={i18n.t('user:email')}
                                        onChange={this.handleChange}
                                        onBlur={this.formValidateEmail}
                                    />
                                    <ControlLabel htmlFor="email" bsClass="input-group-addon">
                                        <InputGroup.Addon bsClass="">
                                            <Glyphicon glyph="envelope" />
                                        </InputGroup.Addon>
                                    </ControlLabel>
                                </InputGroup>
                                {this.renderError('email')}
                                <HelpBlock>
                                    <ul className="list-unstyled">
                                        {this.state.hasZeroBounceError && (
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: i18n.t('subscription:zero-bounce.email.error')
                                                }}
                                            />
                                        )}
                                    </ul>
                                </HelpBlock>
                            </FormGroup>

                            <FormGroup
                                controlId="password"
                                bsSize="large"
                                validationState={this.getValidationState('password')}
                            >
                                <ControlLabel srOnly>{i18n.t('user:password')}</ControlLabel>
                                <InputGroup>
                                    <InputPassword
                                        name="password"
                                        value={this.state.password}
                                        placeholder={i18n.t('user:password')}
                                        onChange={this.handleChange}
                                        onBlur={this.formValidatePassword}
                                    />
                                    <ControlLabel htmlFor="password" bsClass="input-group-addon">
                                        <InputGroup.Addon bsClass="">
                                            <Glyphicon glyph="lock" />
                                        </InputGroup.Addon>
                                    </ControlLabel>
                                </InputGroup>
                                {this.renderError('password')}
                            </FormGroup>

                            {!Utils.getParameter('sponsorkey', null) && (
                                <FormGroup
                                    controlId="sponsor"
                                    bsSize="large"
                                    validationState={this.getValidationState('sponsor')}
                                >
                                    <InputDropdown
                                        name="sponsor"
                                        text={i18n.t('common:signup.referral.text')}
                                        placeholder={i18n.t('common:signup.referral.placeholder')}
                                        onDropdown={this.handleOnDropdownSponsorCode}
                                        onChange={this.handleOnChangeSponsorCode}
                                        onBlur={this.formValidateSponsorCode}
                                    />
                                    {!this.state.hiddenSponsor && this.renderError('sponsor')}
                                </FormGroup>
                            )}

                            <span className="separator"></span>

                            <p className="text-block">
                                <Checkbox
                                    name="cgu"
                                    onChange={this.handleChange}
                                    value={this.state.cgu}
                                    inline
                                    validationState={this.getValidationState('cgu')}
                                >
                                    {i18n.t('common:signup_cgu')}{' '}
                                    <a href={i18n.t('url:cgu.url')} target="_blank" rel="noopener noreferrer">
                                        {i18n.t('common:cgu')}
                                    </a>
                                </Checkbox>
                                {this.renderError('cgu')}
                            </p>

                            <Button
                                type="submit"
                                onClick={() =>
                                    this.onTrackNavigationButton(
                                        NAVIGATION_AREAS.SIGN_UP_EMAIL_MODAL,
                                        NAVIGATION_TEXT.SIGN_UP
                                    )
                                }
                                block
                                bsStyle="primary"
                                bsSize="large"
                                className={classNames('btn-ajax', {
                                    sending: this.state.submit
                                })}
                                disabled={
                                    (this.state.submit && !this.hasEmailNotUniqueError()) ||
                                    (!this.state.submit && this.hasEmailNotUniqueError()) ||
                                    this.getErrors('sponsor') !== undefined
                                }
                            >
                                {i18n.t('common:signup')}
                            </Button>
                        </form>
                        <div className="signup-footer">
                            {i18n.t('already_registrer')}
                            <SigninLink onClick={this.signin} />
                        </div>
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }

    renderError(field) {
        const errors = this.getErrors(field);
        if (errors?.length > 0) {
            return (
                <HelpBlock>
                    <ul className="list-unstyled">
                        {errors.map((error) => (
                            <li key={error}>
                                {error === 'account_creation_failed' ? (
                                    <Trans
                                        i18nKey="common:email_not_unique"
                                        components={
                                            <SigninLink
                                                onClick={this.signin}
                                                text="email_not_unique_redirect_login_link"
                                            />
                                        }
                                        i18n={i18n}
                                    />
                                ) : (
                                    i18n.t(`common:${error}`)
                                )}
                            </li>
                        ))}
                    </ul>
                </HelpBlock>
            );
        }
    }
}

export default EmailSignup;
